import styled from 'styled-components'
import {blackLight} from "../../Theme";

export const Wrapper = styled.div`
  background-color: ${blackLight};
`